// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WebRouteRouteImport } from './routes/_web/route'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as WebIndexRouteImport } from './routes/_web/index'
import { Route as WebContactRouteImport } from './routes/_web/contact'
import { Route as WebPrivacyPolicyRouteImport } from './routes/_web/privacy-policy'
import { Route as WebSupportRouteImport } from './routes/_web/support'
import { Route as WebTosRouteImport } from './routes/_web/tos'
import { Route as WebWaitlistRouteImport } from './routes/_web/waitlist'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppAdminRouteRouteImport } from './routes/app/admin/route'
import { Route as AppDashboardRouteImport } from './routes/app/dashboard'
import { Route as AppGithubCallbackRouteImport } from './routes/app/github-callback'
import { Route as AppIssuesRouteImport } from './routes/app/issues'
import { Route as InvitationsIdRouteImport } from './routes/invitations/$id'
import { Route as AppAdminIndexRouteImport } from './routes/app/admin/index'
import { Route as AppAdminObservabilityRouteImport } from './routes/app/admin/observability'
import { Route as AppAdminUsersRouteImport } from './routes/app/admin/users'
import { Route as AppOrganizationIdIndexRouteImport } from './routes/app/organization/$id/index'
import { Route as AppOrganizationIdMembersRouteImport } from './routes/app/organization/$id/members'
import { Route as AppOrganizationIdSettingsRouteRouteImport } from './routes/app/organization/$id/settings/route'
import { Route as AppProjectIdIndexRouteImport } from './routes/app/project/$id/index'
import { Route as AppProjectIdSettingsRouteImport } from './routes/app/project/$id/settings'
import { Route as AppOrganizationIdAzdoAddRouteImport } from './routes/app/organization/$id/azdo/add'
import { Route as AppOrganizationIdClustersAddRouteImport } from './routes/app/organization/$id/clusters/add'
import { Route as AppOrganizationIdSentryAddRouteImport } from './routes/app/organization/$id/sentry/add'
import { Route as AppOrganizationIdSettingsIndexRouteImport } from './routes/app/organization/$id/settings/index'
import { Route as AppOrganizationIdSettingsAzureDevopsRouteImport } from './routes/app/organization/$id/settings/azure-devops'
import { Route as AppOrganizationIdSettingsAzureDevopsMappingsRouteImport } from './routes/app/organization/$id/settings/azure-devops-mappings'
import { Route as AppOrganizationIdSettingsK8sClustersRouteImport } from './routes/app/organization/$id/settings/k8s-clusters'
import { Route as AppOrganizationIdSettingsK8sMetricsRouteImport } from './routes/app/organization/$id/settings/k8s-metrics'
import { Route as AppOrganizationIdSettingsRepoMappingsRouteImport } from './routes/app/organization/$id/settings/repo-mappings'
import { Route as AppOrganizationIdSettingsSentryRouteImport } from './routes/app/organization/$id/settings/sentry'
import { Route as AppOrganizationIdSettingsSentryMappingsRouteImport } from './routes/app/organization/$id/settings/sentry-mappings'
import { Route as AppOrganizationIdAzdoConnectionIdEditRouteImport } from './routes/app/organization/$id/azdo/$connectionId/edit'
import { Route as AppOrganizationIdClustersClusterIdEditRouteImport } from './routes/app/organization/$id/clusters/$clusterId/edit'
import { Route as AppOrganizationIdSentryConnectionIdEditRouteImport } from './routes/app/organization/$id/sentry/$connectionId/edit'
import { Route as AppOrganizationIdSettingsGithubIndexRouteImport } from './routes/app/organization/$id/settings/github/index'
import { Route as AppOrganizationIdSettingsGithubAssigneesRouteImport } from './routes/app/organization/$id/settings/github/assignees'
import { Route as AppOrganizationIdSettingsGithubBotsRouteImport } from './routes/app/organization/$id/settings/github/bots'
import { Route as AppOrganizationIdSettingsGithubConfigRouteImport } from './routes/app/organization/$id/settings/github/config'
import { Route as AppOrganizationIdSettingsGithubIssueCreationRouteImport } from './routes/app/organization/$id/settings/github/issue-creation'
import { Route as AppProjectIdAgentsAgentIdIndexRouteImport } from './routes/app/project/$id/agents/$agentId/index'
import { Route as AppProjectIdAgentsAgentIdRunsRunIdIndexRouteImport } from './routes/app/project/$id/agents/$agentId/runs/$runId/index'

const WebRouteRoute = WebRouteRouteImport.update({
            id: '/_web',getParentRoute: () => rootRouteImport
          })
const AppRouteRoute = AppRouteRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const SignInRoute = SignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => rootRouteImport
          })
const SignUpRoute = SignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => rootRouteImport
          })
const WebIndexRoute = WebIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => WebRouteRoute
          })
const WebContactRoute = WebContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => WebRouteRoute
          })
const WebPrivacyPolicyRoute = WebPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => WebRouteRoute
          })
const WebSupportRoute = WebSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => WebRouteRoute
          })
const WebTosRoute = WebTosRouteImport.update({
            id: '/tos',path: '/tos',getParentRoute: () => WebRouteRoute
          })
const WebWaitlistRoute = WebWaitlistRouteImport.update({
            id: '/waitlist',path: '/waitlist',getParentRoute: () => WebRouteRoute
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRouteRoute
          })
const AppAdminRouteRoute = AppAdminRouteRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AppRouteRoute
          })
const AppDashboardRoute = AppDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AppRouteRoute
          })
const AppGithubCallbackRoute = AppGithubCallbackRouteImport.update({
            id: '/github-callback',path: '/github-callback',getParentRoute: () => AppRouteRoute
          })
const AppIssuesRoute = AppIssuesRouteImport.update({
            id: '/issues',path: '/issues',getParentRoute: () => AppRouteRoute
          })
const InvitationsIdRoute = InvitationsIdRouteImport.update({
            id: '/invitations/$id',path: '/invitations/$id',getParentRoute: () => rootRouteImport
          })
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppAdminRouteRoute
          })
const AppAdminObservabilityRoute = AppAdminObservabilityRouteImport.update({
            id: '/observability',path: '/observability',getParentRoute: () => AppAdminRouteRoute
          })
const AppAdminUsersRoute = AppAdminUsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => AppAdminRouteRoute
          })
const AppOrganizationIdIndexRoute = AppOrganizationIdIndexRouteImport.update({
            id: '/organization/$id/',path: '/organization/$id/',getParentRoute: () => AppRouteRoute
          })
const AppOrganizationIdMembersRoute = AppOrganizationIdMembersRouteImport.update({
            id: '/organization/$id/members',path: '/organization/$id/members',getParentRoute: () => AppRouteRoute
          })
const AppOrganizationIdSettingsRouteRoute = AppOrganizationIdSettingsRouteRouteImport.update({
            id: '/organization/$id/settings',path: '/organization/$id/settings',getParentRoute: () => AppRouteRoute
          })
const AppProjectIdIndexRoute = AppProjectIdIndexRouteImport.update({
            id: '/project/$id/',path: '/project/$id/',getParentRoute: () => AppRouteRoute
          })
const AppProjectIdSettingsRoute = AppProjectIdSettingsRouteImport.update({
            id: '/project/$id/settings',path: '/project/$id/settings',getParentRoute: () => AppRouteRoute
          })
const AppOrganizationIdAzdoAddRoute = AppOrganizationIdAzdoAddRouteImport.update({
            id: '/organization/$id/azdo/add',path: '/organization/$id/azdo/add',getParentRoute: () => AppRouteRoute
          })
const AppOrganizationIdClustersAddRoute = AppOrganizationIdClustersAddRouteImport.update({
            id: '/organization/$id/clusters/add',path: '/organization/$id/clusters/add',getParentRoute: () => AppRouteRoute
          })
const AppOrganizationIdSentryAddRoute = AppOrganizationIdSentryAddRouteImport.update({
            id: '/organization/$id/sentry/add',path: '/organization/$id/sentry/add',getParentRoute: () => AppRouteRoute
          })
const AppOrganizationIdSettingsIndexRoute = AppOrganizationIdSettingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppOrganizationIdSettingsRouteRoute
          })
const AppOrganizationIdSettingsAzureDevopsRoute = AppOrganizationIdSettingsAzureDevopsRouteImport.update({
            id: '/azure-devops',path: '/azure-devops',getParentRoute: () => AppOrganizationIdSettingsRouteRoute
          })
const AppOrganizationIdSettingsAzureDevopsMappingsRoute = AppOrganizationIdSettingsAzureDevopsMappingsRouteImport.update({
            id: '/azure-devops-mappings',path: '/azure-devops-mappings',getParentRoute: () => AppOrganizationIdSettingsRouteRoute
          })
const AppOrganizationIdSettingsK8sClustersRoute = AppOrganizationIdSettingsK8sClustersRouteImport.update({
            id: '/k8s-clusters',path: '/k8s-clusters',getParentRoute: () => AppOrganizationIdSettingsRouteRoute
          })
const AppOrganizationIdSettingsK8sMetricsRoute = AppOrganizationIdSettingsK8sMetricsRouteImport.update({
            id: '/k8s-metrics',path: '/k8s-metrics',getParentRoute: () => AppOrganizationIdSettingsRouteRoute
          })
const AppOrganizationIdSettingsRepoMappingsRoute = AppOrganizationIdSettingsRepoMappingsRouteImport.update({
            id: '/repo-mappings',path: '/repo-mappings',getParentRoute: () => AppOrganizationIdSettingsRouteRoute
          })
const AppOrganizationIdSettingsSentryRoute = AppOrganizationIdSettingsSentryRouteImport.update({
            id: '/sentry',path: '/sentry',getParentRoute: () => AppOrganizationIdSettingsRouteRoute
          })
const AppOrganizationIdSettingsSentryMappingsRoute = AppOrganizationIdSettingsSentryMappingsRouteImport.update({
            id: '/sentry-mappings',path: '/sentry-mappings',getParentRoute: () => AppOrganizationIdSettingsRouteRoute
          })
const AppOrganizationIdAzdoConnectionIdEditRoute = AppOrganizationIdAzdoConnectionIdEditRouteImport.update({
            id: '/organization/$id/azdo/$connectionId/edit',path: '/organization/$id/azdo/$connectionId/edit',getParentRoute: () => AppRouteRoute
          })
const AppOrganizationIdClustersClusterIdEditRoute = AppOrganizationIdClustersClusterIdEditRouteImport.update({
            id: '/organization/$id/clusters/$clusterId/edit',path: '/organization/$id/clusters/$clusterId/edit',getParentRoute: () => AppRouteRoute
          })
const AppOrganizationIdSentryConnectionIdEditRoute = AppOrganizationIdSentryConnectionIdEditRouteImport.update({
            id: '/organization/$id/sentry/$connectionId/edit',path: '/organization/$id/sentry/$connectionId/edit',getParentRoute: () => AppRouteRoute
          })
const AppOrganizationIdSettingsGithubIndexRoute = AppOrganizationIdSettingsGithubIndexRouteImport.update({
            id: '/github/',path: '/github/',getParentRoute: () => AppOrganizationIdSettingsRouteRoute
          })
const AppOrganizationIdSettingsGithubAssigneesRoute = AppOrganizationIdSettingsGithubAssigneesRouteImport.update({
            id: '/github/assignees',path: '/github/assignees',getParentRoute: () => AppOrganizationIdSettingsRouteRoute
          })
const AppOrganizationIdSettingsGithubBotsRoute = AppOrganizationIdSettingsGithubBotsRouteImport.update({
            id: '/github/bots',path: '/github/bots',getParentRoute: () => AppOrganizationIdSettingsRouteRoute
          })
const AppOrganizationIdSettingsGithubConfigRoute = AppOrganizationIdSettingsGithubConfigRouteImport.update({
            id: '/github/config',path: '/github/config',getParentRoute: () => AppOrganizationIdSettingsRouteRoute
          })
const AppOrganizationIdSettingsGithubIssueCreationRoute = AppOrganizationIdSettingsGithubIssueCreationRouteImport.update({
            id: '/github/issue-creation',path: '/github/issue-creation',getParentRoute: () => AppOrganizationIdSettingsRouteRoute
          })
const AppProjectIdAgentsAgentIdIndexRoute = AppProjectIdAgentsAgentIdIndexRouteImport.update({
            id: '/project/$id/agents/$agentId/',path: '/project/$id/agents/$agentId/',getParentRoute: () => AppRouteRoute
          })
const AppProjectIdAgentsAgentIdRunsRunIdIndexRoute = AppProjectIdAgentsAgentIdRunsRunIdIndexRouteImport.update({
            id: '/project/$id/agents/$agentId/runs/$runId/',path: '/project/$id/agents/$agentId/runs/$runId/',getParentRoute: () => AppRouteRoute
          })





const WebRouteRouteChildren = {
  WebContactRoute: WebContactRoute,WebPrivacyPolicyRoute: WebPrivacyPolicyRoute,WebSupportRoute: WebSupportRoute,WebTosRoute: WebTosRoute,WebWaitlistRoute: WebWaitlistRoute,WebIndexRoute: WebIndexRoute
}

const WebRouteRouteWithChildren = WebRouteRoute._addFileChildren(WebRouteRouteChildren)




const AppAdminRouteRouteChildren = {
  AppAdminObservabilityRoute: AppAdminObservabilityRoute,AppAdminUsersRoute: AppAdminUsersRoute,AppAdminIndexRoute: AppAdminIndexRoute
}

const AppAdminRouteRouteWithChildren = AppAdminRouteRoute._addFileChildren(AppAdminRouteRouteChildren)




const AppOrganizationIdSettingsRouteRouteChildren = {
  AppOrganizationIdSettingsAzureDevopsRoute: AppOrganizationIdSettingsAzureDevopsRoute,AppOrganizationIdSettingsAzureDevopsMappingsRoute: AppOrganizationIdSettingsAzureDevopsMappingsRoute,AppOrganizationIdSettingsK8sClustersRoute: AppOrganizationIdSettingsK8sClustersRoute,AppOrganizationIdSettingsK8sMetricsRoute: AppOrganizationIdSettingsK8sMetricsRoute,AppOrganizationIdSettingsRepoMappingsRoute: AppOrganizationIdSettingsRepoMappingsRoute,AppOrganizationIdSettingsSentryRoute: AppOrganizationIdSettingsSentryRoute,AppOrganizationIdSettingsSentryMappingsRoute: AppOrganizationIdSettingsSentryMappingsRoute,AppOrganizationIdSettingsIndexRoute: AppOrganizationIdSettingsIndexRoute,AppOrganizationIdSettingsGithubAssigneesRoute: AppOrganizationIdSettingsGithubAssigneesRoute,AppOrganizationIdSettingsGithubBotsRoute: AppOrganizationIdSettingsGithubBotsRoute,AppOrganizationIdSettingsGithubConfigRoute: AppOrganizationIdSettingsGithubConfigRoute,AppOrganizationIdSettingsGithubIssueCreationRoute: AppOrganizationIdSettingsGithubIssueCreationRoute,AppOrganizationIdSettingsGithubIndexRoute: AppOrganizationIdSettingsGithubIndexRoute
}

const AppOrganizationIdSettingsRouteRouteWithChildren = AppOrganizationIdSettingsRouteRoute._addFileChildren(AppOrganizationIdSettingsRouteRouteChildren)



const AppRouteRouteChildren = {
  AppAdminRouteRoute: AppAdminRouteRouteWithChildren,AppDashboardRoute: AppDashboardRoute,AppGithubCallbackRoute: AppGithubCallbackRoute,AppIssuesRoute: AppIssuesRoute,AppIndexRoute: AppIndexRoute,AppOrganizationIdSettingsRouteRoute: AppOrganizationIdSettingsRouteRouteWithChildren,AppOrganizationIdMembersRoute: AppOrganizationIdMembersRoute,AppProjectIdSettingsRoute: AppProjectIdSettingsRoute,AppOrganizationIdIndexRoute: AppOrganizationIdIndexRoute,AppProjectIdIndexRoute: AppProjectIdIndexRoute,AppOrganizationIdAzdoAddRoute: AppOrganizationIdAzdoAddRoute,AppOrganizationIdClustersAddRoute: AppOrganizationIdClustersAddRoute,AppOrganizationIdSentryAddRoute: AppOrganizationIdSentryAddRoute,AppOrganizationIdAzdoConnectionIdEditRoute: AppOrganizationIdAzdoConnectionIdEditRoute,AppOrganizationIdClustersClusterIdEditRoute: AppOrganizationIdClustersClusterIdEditRoute,AppOrganizationIdSentryConnectionIdEditRoute: AppOrganizationIdSentryConnectionIdEditRoute,AppProjectIdAgentsAgentIdIndexRoute: AppProjectIdAgentsAgentIdIndexRoute,AppProjectIdAgentsAgentIdRunsRunIdIndexRoute: AppProjectIdAgentsAgentIdRunsRunIdIndexRoute
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(AppRouteRouteChildren)

const rootRouteChildren = {
  WebRouteRoute: WebRouteRouteWithChildren,AppRouteRoute: AppRouteRouteWithChildren,SignInRoute: SignInRoute,SignUpRoute: SignUpRoute,InvitationsIdRoute: InvitationsIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)